import { BASE_URL_API } from 'constants/base-url-default'

type Body = {
  email: string
}

export const fetchForgotPassword = async (data: Body) => {
  const response = await fetch(`${BASE_URL_API}/forgot-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  if (response.status !== 200) {
    throw new Error('Erro ao enviar e-mail')
  }
}
